import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

import { Admin } from '../';
import { SessionStorageService } from '../../core/services';

@Injectable()
export class AdminService {
    // Observable Admin source
    public loggedIn: boolean;
    protected adminDataChangedSource = new Subject<Admin>();
    protected logger = new Subject<boolean>();
    // Observable Admin streams
    adminDataChanged$ = this.adminDataChangedSource.asObservable();

    constructor(
        private sessionStorageService: SessionStorageService
    ) {    
    }
    
    getAdminSessionData(): Admin {
        return this.sessionStorageService.getData<Admin>('asa-admin');
    }

    setAdminSessionData(admin: Admin): boolean {
        return this.sessionStorageService.setData('asa-admin', admin);
    }

    clearAdminSessionData(): boolean {
        return this.sessionStorageService.removeData('asa-admin');
    }

    clearInterSession(): boolean {
        return this.sessionStorageService.removeData('curId');
    }

    adminDataChanged(admin: Admin) {
        return this.adminDataChangedSource.next(admin);
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/admin/services/AdminService.ts